/* =====================================================================
   DEAD COTTON — Tiroir panier (portage de renderCart() / openDrawer() du prototype, assets/app.js ; étape 5b, 2026-10-12)
   - Le contenu est rendu par la section Liquid `dc-cart-drawer` (vrai panier Shopify) ; ici on le recharge avec l'API Section Rendering
     (`/?sections=cart-icon-bubble,dc-cart-drawer`) après chaque changement, puis on ouvre le tiroir.
   - window.dcOpenCart() : recharge + ouvre (appelé après « Ajouter » depuis la fiche, la barre fixe et les cartes).
   - Quantités / suppression : POST /cart/change.js avec la clé de ligne.
   - La coque (.dc-drawer, .dc-overlay, Échap, clic sur le fond) est la même que celle du tiroir menu (dc-site.js).
   ===================================================================== */
(function () {
  "use strict";
  var SEC = "dc-cart-drawer";
  var overlay = document.querySelector("[data-dc-overlay]");
  var busy = false;

  function drawer() { return document.querySelector("[data-dc-drawer='cart']"); }

  function open() {
    var d = drawer();
    if (!d) return;
    void d.offsetWidth;   // force le calcul du style « fermé » avant d'ajouter la classe : le tiroir glisse au lieu d'apparaître d'un coup
    d.classList.add("dc-is-open");
    if (overlay) overlay.classList.add("dc-is-open");
    document.body.style.overflow = "hidden";
  }
  function close() {
    document.querySelectorAll(".dc-drawer").forEach(function (d) { d.classList.remove("dc-is-open"); });
    if (overlay) overlay.classList.remove("dc-is-open");
    document.body.style.overflow = "";
  }

  function inner(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var sec = doc.querySelector(".shopify-section");
    return sec ? sec.innerHTML : html;
  }

  /* Recharge le point rose du panier (en-tête) et le contenu du tiroir */
  function refresh() {
    return fetch("/?sections=cart-icon-bubble," + SEC)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var bubble = document.querySelector("#cart-icon-bubble");
        if (data["cart-icon-bubble"] && bubble) bubble.innerHTML = inner(data["cart-icon-bubble"]);
        var wrap = document.getElementById("shopify-section-" + SEC);
        if (data[SEC] && wrap) {
          var wasOpen = drawer() && drawer().classList.contains("dc-is-open");
          wrap.innerHTML = inner(data[SEC]);
          if (wasOpen) drawer().classList.add("dc-is-open");
          initSuggest();
        }
      });
  }

  /* Suggestions « Tu aimeras aussi » : une carte à la fois, flèches grisées aux extrémités (le swipe marche tout seul) */
  function initSuggest() {
    var d = drawer();
    var track = d && d.querySelector("[data-dc-sug-track]");
    if (!track) return;
    var prev = d.querySelector("[data-dc-sug-prev]"), next = d.querySelector("[data-dc-sug-next]");
    var step = function () { return (track.children.length > 1 ? track.children[1].offsetLeft - track.children[0].offsetLeft : track.clientWidth) || 1; };
    var update = function () {
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    track.addEventListener("scroll", update, { passive: true });
    update();
  }

  function change(key, qty) {
    if (busy) return;
    busy = true;
    var body = drawer() && drawer().querySelector("[data-dc-cart-body]");
    if (body) body.style.opacity = ".55";
    // Bloc duo : plusieurs clés de ligne séparées par des virgules -> mise à jour groupée
    var multi = String(key).indexOf(",") >= 0;
    var updates = {};
    if (multi) String(key).split(",").forEach(function (k) { updates[k] = qty; });
    fetch(multi ? "/cart/update.js" : "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(multi ? { updates: updates } : { id: key, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error("change"); return refresh(); })
      .catch(function () { /* on laisse le contenu tel quel */ })
      .then(function () { busy = false; var b = drawer() && drawer().querySelector("[data-dc-cart-body]"); if (b) b.style.opacity = ""; });
  }

  window.dcOpenCart = function () { return refresh().then(open); };
  window.dcRefreshCart = refresh;

  document.addEventListener("click", function (e) {
    // Icône panier de l'en-tête : ouvre le tiroir (le lien vers /cart reste le repli sans JavaScript)
    var opener = e.target.closest("[data-dc-open-cart]");
    if (opener && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) {
      e.preventDefault();
      window.dcOpenCart();
      return;
    }
    var closer = e.target.closest("[data-dc-close-drawer]");
    if (closer && closer.closest("[data-dc-drawer='cart']")) { close(); return; }
    var q = e.target.closest("[data-dc-qty]");
    if (q) { change(q.getAttribute("data-key"), Math.max(0, parseInt(q.getAttribute("data-qty-now"), 10) + parseInt(q.getAttribute("data-dc-qty"), 10))); return; }
    var rm = e.target.closest("[data-dc-remove]");
    if (rm) change(rm.getAttribute("data-dc-remove"), 0);
  });

  initSuggest();
})();
